import React, { memo } from 'react';
import {
  Box,
  Typography,
  Chip,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

interface ChatHeaderProps {
  isConnected: boolean;
}

export const ChatHeader = memo<ChatHeaderProps>(({ isConnected }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
      }}
    >
      <Typography variant="body2" fontWeight="500" fontSize="0.875rem">
        LedgerX Assistant
      </Typography>
      <Chip
        label={isConnected ? 'Online' : 'Offline'}
        size="small"
        color={isConnected ? 'success' : 'default'}
        sx={{ 
          height: 20,
          fontSize: '0.7rem',
          '& .MuiChip-label': {
            px: 1,
          },
        }}
      />
    </Box>
  );
});

ChatHeader.displayName = 'ChatHeader';

